import { App } from 'App';

// Strips whitespace, non-numeric chars (except +), and the configured country code prefix
export const phoneSanitizer = (value: string) =>
  value
    .trim()
    .replace(/[^0-9+]/g, '')
    .replace(App.config.phoneCountryCode, '');

// Removes all whitespace characters from a string
export const spacesSanitizer = (value: string) => value.replace(/\s/g, '');

export const forceTwoDigits = (count: number | undefined) => {
  if (!count) return '00';
  if (count < 10) return `0${count}`;
  return count.toString();
};

export const phoneMaskedSanitized = (value?: string) => {
  if (!value) return '';
  const last3DigitsIndex = value.length - 3;
  const firstDigit = value.slice(0, 1);
  const lastDigits = value.slice(last3DigitsIndex);
  return `${firstDigit}** *** ${lastDigits}`;
};
